// extracted by mini-css-extract-plugin
module.exports = {"title":"comment-module__title___2eJzn","container":"comment-module__container___qtAF2","comment":"comment-module__comment___1WuzY"};